import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Injectable({ providedIn: 'root' })
export class AlwaysAuthGuard implements CanActivate {
  public SuperAdmin = [
    "project_dashboard",
    "dashboard_view",
    "user_creation",
    "master_creation",
    "form_configuration",
    "form_list",
    "form_reports",
    "entry_form",
    "project_details",
    "form_submission",
    "reset_password",
    "project_analytics"
  ];
  public Admin = [
    "user_creation",
    "master_creation",
    "form_configuration",
    "form_list",
    "form_reports",
    "form_submission",
    "project_details",
    "project_dashboard",
    "reset_password"
  ];
  public User = [
    "form_list",
    "form_reports",
    "form_submission",
    // "project_details",
    // "project_dashboard",
    "reset_password"
  ];
  permissionArray:any;
  userRole:any;  
  constructor(private router: Router,
    private authService: AuthService
  ) {
    this.userRole = sessionStorage.getItem('user_category_code');
    this.permissionArray = [];
    this.userRole === 'SUPER_ADMIN' ? this.permissionArray = this.SuperAdmin : this.userRole === 'ADMIN' ? this.permissionArray = this.Admin : this.permissionArray = this.User;
  }

  canActivate(route: ActivatedRouteSnapshot, _routerState: RouterStateSnapshot): boolean {
    const token = sessionStorage.getItem('token');
    if (!token) {
      this.router.navigate(['/login']);
      return false;
    }
    const isPermission = this.permissionArray.includes(route.routeConfig?.path);
    if(!isPermission && this.userRole !== 'USER'){
      this.router.navigate(['/project_dashboard']);
      return false;
    } else if(!isPermission){
      this.router.navigate(['/form_submission']);
      return false;
    }
    // let mainModule = _routerState?.url.split('/')[1];
    // if (routePath && !this.authService.hasElementPermission(routePath)) {
    //   this.router.navigate(['/no-permission']);
    //   return false;
    // }
    return true;
  }

}
